import LinkT from '@/Controls/Link';
import ControlBuilder from '@/Builder/ControlBuilder';
import LinkViewModelBuilder from '@/Builder/LinkViewModelBuilder';
import ComponentManager from '@/Management/ComponentManager';

export default class LinkBuilder<T = null> extends ControlBuilder<LinkT, T> {

    private viewModelBuilder: LinkViewModelBuilder<this>;

    public constructor(parent?: T) {
        super(parent);
    }

    public withViewModel(): LinkViewModelBuilder<this> {
        if (this.viewModelBuilder == null)
            this.viewModelBuilder = new LinkViewModelBuilder<this>(this);

        return this.viewModelBuilder;
    }

    /**
     * @override
     * @inheritdoc 
     */
    protected buildInternal(): LinkT {
        const Link = ComponentManager.getControl<typeof LinkT>('Link');

        return new Link(this.viewModelBuilder.build());
    }
}